<template>
  <div style="text-align: center;">
    <b-row>
      <img src="@/assets/images/topBanner/dort.png" alt="topBanner" />
    </b-row> 
  </div>
</template>

<script>
export default {
  methods: {
    topBannerRef() {

    },
  },
};
</script>
